export const QA_NAME_EDIT_RATING_MODAL = 'editRating'

export const RATING_TYPE_OVERALL = 1

export const RATING_TYPE_MANAGEMENT_COMPANY = 2

export const RATING_TYPE_CONTRACTOR = 3

export const RATING_TYPE_LABEL_KEY = {
  [RATING_TYPE_CONTRACTOR]: 'Rating.ContractorLabelKey',
  [RATING_TYPE_MANAGEMENT_COMPANY]: 'Rating.ManagementCompanyLabelKey',
  [RATING_TYPE_OVERALL]: 'Rating.OverallLabelKey',
}

export const RATING_TYPE_LIST = [
  RATING_TYPE_OVERALL,
  RATING_TYPE_MANAGEMENT_COMPANY,
  RATING_TYPE_CONTRACTOR,
]

export const RATING_EDIT_MODAL_MAX_COMMENT_LENGTH = 2000
